import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Row } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDetectScroll } from "@faire/web--source/ui/hooks/useDetectScroll";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackR2BReferralsClicksOnSignUpToSellButtonClick } from "@faire/web-api--source/events/r2BReferrals/click/clicksOnSignUpToSellButton";
import brands from "@faire/web-api--source/routes/brands";
import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
var FAIRE_LOGO_WIDTH = 120;
var CTA_CONTAINER_HEIGHT = 40;
var VERTICAL_PADDING = 16;
var HEADER_HEIGHT = 2 * VERTICAL_PADDING + CTA_CONTAINER_HEIGHT;
var TOP_SECTION_HEIGHT = 490;
export var Header = function(param) {
    var showCTA = param.showCTA, setShowCTA = param.setShowCTA;
    var _useViewport = useViewport(), isTabletAndAbove = _useViewport.isTabletAndAbove, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    var _useState = _sliced_to_array(useState(false), 2), hasScrolled = _useState[0], setHasScrolled = _useState[1];
    var scrollPosition = useDetectScroll().scrollPosition;
    useEffect(function() {
        if (isTabletAndAbove) {
            if (!showCTA && scrollPosition > HEADER_HEIGHT + TOP_SECTION_HEIGHT) {
                setHasScrolled(true);
                setShowCTA(true);
            } else if (showCTA && scrollPosition < HEADER_HEIGHT + TOP_SECTION_HEIGHT) {
                setShowCTA(false);
            }
        }
    }, [
        isTabletAndAbove,
        scrollPosition,
        showCTA,
        setShowCTA
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: brands(),
                children: /*#__PURE__*/ _jsx(FaireLogo, {
                    inverse: true,
                    size: FAIRE_LOGO_WIDTH
                })
            }),
            hasScrolled && isTabletAndAbove ? /*#__PURE__*/ _jsxs(CTAContainer, {
                $showCTA: showCTA,
                children: [
                    isDesktopAndAbove ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                color: Core.surface.inverse,
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "OO58SM",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Connect with our team to learn about your potential on Faire."
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "5x"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(SignUpButton, {
                        tertiaryColor: Core.text.inverse,
                        onClick: trackR2BReferralsClicksOnSignUpToSellButtonClick,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "JUZwnu",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Sign up to sell"
                                }
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
};
var Container = styled(Row).attrs({
    align: "center",
    justify: {
        mobileAndAbove: "center",
        tabletAndAbove: "space-between"
    }
}).withConfig({
    componentId: "sc-374ace79-0"
})([
    "position:sticky;top:0;z-index:2;width:100%;height:",
    "px;background-color:",
    ";padding:",
    ";",
    "{padding:",
    ";}"
], HEADER_HEIGHT, Decorative.shade.yellow, getSpacing(VERTICAL_PADDING, "10x"), responsiveMediaQueries.mobile, getSpacing(VERTICAL_PADDING, "3x"));
var slideUpAnimation = keyframes([
    "0%{transform:translateY(",
    "px);}100%{transform:translateY(0);}"
], VERTICAL_PADDING);
var slideDownAnimation = keyframes([
    "0%{transform:translateY(0);}100%{transform:translateY(",
    "px);visibility:hidden;}"
], VERTICAL_PADDING);
var CTAContainer = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-374ace79-1"
})([
    "animation:",
    " 0.3s ease-in-out;animation-fill-mode:both;height:",
    "px;"
], function(param) {
    var showCTA = param.$showCTA;
    return showCTA ? slideUpAnimation : slideDownAnimation;
}, CTA_CONTAINER_HEIGHT);
var SignUpButton = styled(Button).attrs({
    variant: "tertiary",
    target: "_blank"
}).withConfig({
    componentId: "sc-374ace79-2"
})([
    "width:max-content;"
]);
